import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import pagePath from "src/pagePath.json";
import { getUserDevice } from "src/utils";
import { skipDeviceRedirectState } from "../recoil/skipDeviceRedirect/atom";

/** 디바이스에 따른 리다이렉트  */

const isMobileDevice = () => {
  const device = getUserDevice();
  return device === "android" || device === "ios";
};

// 허용된 경로에서만 리다이렉트 허용
const isAllowedRedirectPath = (path: string) => {
  const allowedPaths = [pagePath.visitor.list, pagePath.visitor.detail, pagePath.visitor.mobileList, pagePath.visitor.mobileDetail];

  if (process.env.REACT_APP_ENVIRONMENT === "dev") {
  }
  return allowedPaths.some((allowedPath) => {
    const pattern = allowedPath.replace(/:\w+/g, "[^/]+");
    const regex = new RegExp(`^${pattern}`);
    return regex.test(path);
  });
};

const DeviceRedirector = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const skipRedirect = useRecoilValue(skipDeviceRedirectState);

  useEffect(() => {
    const baseUrl = "/mng/ctrl/partners/";
    const mobileUrl = "/mng/ctrl/mobile/partners/";

    if (!location.pathname.startsWith(baseUrl) && !location.pathname.startsWith(mobileUrl)) {
      return;
    }

    if (skipRedirect) return;

    if (!isAllowedRedirectPath(location.pathname)) return;

    const isMobile = isMobileDevice();

    if (location.pathname.startsWith(baseUrl)) {
      if (isMobile) {
        navigate(location.pathname.replace(baseUrl, mobileUrl), { replace: true });
      }
    } else if (location.pathname.startsWith(mobileUrl)) {
      if (!isMobile) {
        navigate(location.pathname.replace(mobileUrl, baseUrl), { replace: true });
      }
    } else return;
  }, [location.pathname, navigate, skipRedirect]);

  return null;
};

export default DeviceRedirector;
